exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pfe-panel[data-v-e9490b54]{width:100%;height:100%;border-right:1px solid #e0e0e0}.pfe-panel-header[data-v-e9490b54]{border-bottom:1px solid #e0e0e0}.pfe-page-active[data-v-e9490b54]{background:rgba(25,118,210,.08)!important}.pfe-doc-merged[data-v-e9490b54]{opacity:.5}", ""]);

// exports
